export const setMunicipios = "set/municipios";
export const setMunicipiosFiltereds = "set/municipiosFiltereds";

export const setLatest = "set/latest"

export const setIsLoading = "set/isLoading";
export const setError = "set/error";

export const resetMunicipiosFiltereds = "reset/municipiosFiltereds";
export const resetEstadosFiltereds = "reset/estadosFiltereds";

export const addMunicipios = "add/addMunicipios";
export const addMunicipiosFiltereds = "add/municipiosFiltereds";
